import React from 'react';
import { Button } from '@fourthwall/components';
import * as S from './KitGetStarted.styled';
export const KitGetStarted = ({ onGetStarted, isLoading }) => {
    const handleGetStarted = async () => {
        try {
            await onGetStarted();
        }
        catch (error) {
            console.error('Failed to get started with Kit:', error);
        }
    };
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, null, "Get Started with Kit"),
        React.createElement(S.Description, null, "Click to button below to sync your members and newsletter subscribers to Kit."),
        React.createElement(S.ButtonContainer, null,
            React.createElement(Button, { label: "Sync Data", appearance: "primary", loading: isLoading, disabled: isLoading, onClick: handleGetStarted }))));
};
